import { render } from "./humanityMuseumHome.vue?vue&type=template&id=1bea1f84&scoped=true"
import script from "./humanityMuseumHome.vue?vue&type=script&lang=js"
export * from "./humanityMuseumHome.vue?vue&type=script&lang=js"

import "./humanityMuseumHome.vue?vue&type=style&index=0&id=1bea1f84&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bea1f84"]])

export default __exports__